module.exports = __webpack_public_path__ + "static/media/23.51a340a0.png";